import { Userbot } from "../../interfaces"

export interface ActionableStepHint {
  text: string
  linkToAccount: boolean
}

interface StaticRule {
  match: string
  text: string
  linkToAccount: boolean
}

const STATIC_RULES: StaticRule[] = [
  {
    match: "USERBOT_2FA_PASSWORD is not configured",
    text: "Конфигурация сервера: не задан системный 2FA-пароль. Обратитесь к администратору.",
    linkToAccount: false,
  },
  {
    match: "client has no linked account",
    text: "У клиента нет привязанного аккаунта.",
    linkToAccount: false,
  },
  {
    match: "twoFaPassword is empty",
    text: "Сохранённый текущий 2FA-пароль пуст — укажите его в карточке аккаунта и перезапустите шаблон.",
    linkToAccount: true,
  },
  {
    match: "PASSWORD_HASH_INVALID",
    text: "Сохранённый текущий пароль неверен (догадка по цифрам телефона не подошла) — исправьте его в карточке аккаунта и перезапустите шаблон.",
    linkToAccount: true,
  },
  {
    match: "account has no phone",
    text: "У аккаунта не указан номер телефона — укажите номер телефона в карточке аккаунта.",
    linkToAccount: true,
  },
  {
    match: "account phone is missing",
    text: "У аккаунта не указан номер телефона — укажите номер телефона в карточке аккаунта.",
    linkToAccount: true,
  },
  {
    match: "peer 777000",
    text: "Не удалось получить доступ к служебному чату Telegram (777000).",
    linkToAccount: false,
  },
  {
    match: "777000 not resolved",
    text: "Не удалось получить доступ к служебному чату Telegram (777000).",
    linkToAccount: false,
  },
  {
    match: "code did not arrive",
    text: "Таймаут: код подтверждения не поступил в чат 777000 за 180 сек.",
    linkToAccount: false,
  },
  {
    match: "code not received within 180",
    text: "Таймаут: код подтверждения не поступил в чат 777000 за 180 сек.",
    linkToAccount: false,
  },
]

/**
 * Разбор actionable-ошибок по подстроке / паттернам в failedReason / errorKind.text.
 * Привязано к смыслу и тексту ошибки, а не к имени действия.
 */
export const actionableStepHint = (
  step: Userbot.ChainReportStep,
): ActionableStepHint | null => {
  const pieces: string[] = []
  if (step.failedReason) pieces.push(step.failedReason)
  if (step.errorKind && step.errorKind.kind === "rpc" && step.errorKind.text) {
    pieces.push(step.errorKind.text)
  }

  const combined = pieces.join(" ")
  if (!combined) return null

  // 1. Динамические правила: fresh sibling с id
  const siblingMatch = combined.match(
    /(?:fresh sibling(?: exists)?|sibling session|sibling client|active fresh sibling)(?:\s*[:=]\s*|\s+id\s*[:=]?\s*|\s+)([a-zA-Z0-9_.-]+)/i,
  )
  if (siblingMatch && siblingMatch[1].toLowerCase() !== "exists") {
    return {
      text: `Повторный запуск заблокирован: существует активная свежая сессия (<48ч): ${siblingMatch[1]}.`,
      linkToAccount: false,
    }
  }
  if (/fresh sibling/i.test(combined)) {
    return {
      text: "Повторный запуск заблокирован: существует активная свежая сессия (<48ч).",
      linkToAccount: false,
    }
  }

  // 2. Код доставлен не в app (sms/call)
  if (
    /(?:code delivered not to app|not sent to app|sentCodeType.*(?:sms|call)|sent via sms|sent via call)/i.test(
      combined,
    )
  ) {
    return {
      text: "Код подтверждения был отправлен через SMS/звонок, а не в приложение Telegram. Онбординг требует код из чата 777000.",
      linkToAccount: false,
    }
  }

  // 3. Таймаут 180с ожидания кода
  if (
    /(?:180s|180 seconds|180 сек|180c)/i.test(combined) &&
    /code/i.test(combined)
  ) {
    return {
      text: "Таймаут: код подтверждения не поступил в чат 777000 за 180 сек.",
      linkToAccount: false,
    }
  }

  // 4. Статические правила
  for (const rule of STATIC_RULES) {
    if (combined.toLowerCase().includes(rule.match.toLowerCase())) {
      return { text: rule.text, linkToAccount: rule.linkToAccount }
    }
  }

  return null
}
